export default __webpack_public_path__ + "static/media/Banner1.ce7f9705.png";